import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import SuccessActionIcon from './SuccessActionIcon';
import { SIDEBAR_ACTIONS } from '../../../../../../constants/actionsConstants';

const SendPDFAction = ({
  order,
  onSendPdf,
  closeParentModal
}) => {
  const { t } = useTranslation('Orders');
  const dispatch = useDispatch();

  const openModal = useCallback(() => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'SendPDFWithPaymentLinksModal',
        props: {
          order,
          onSendPdf
        }
      }
    });

    closeParentModal();
  }, [closeParentModal, dispatch, order]);

  return (
    <div className="tw-flex tw-flex-col tw-items-center">
      <SuccessActionIcon
        icon="new-document"
        title={t('orderSaved.sendPDF')}
        subtitle={t('orderSaved.purchase')}
        onClick={openModal}
      />
    </div>
  );
};

export default memo(SendPDFAction);
